(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["content-tabs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('content-tabs')) {
  customElements.define(
    'content-tabs',
    class ContentTabs extends HTMLElement {
      connectedCallback() {
        this.buttons = Array.from(this.querySelectorAll('.content-tab-button'));
        this.tabs = Array.from(this.querySelectorAll('.content-tab'));
        this.panels = this.querySelector('.content-tabs__panels');
        this.activeBg = this.querySelector('.content-tabs__active-bg');

        this.buttons.forEach((button) => {
          button.addEventListener('click', () => this.select(Number(button.dataset.index)));
          button.addEventListener('keydown', (event) => this.onKeydown(event));
        });

        this.observer = new ResizeObserver(() => this.refresh(false));
        this.observer.observe(this);
        this.tabs.forEach((tab) => this.observer.observe(tab));

        this.classList.add('content-tabs--initialized');
        this.refresh(false);
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      onKeydown(event) {
        if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
        const current = this.buttons.indexOf(document.activeElement);
        if (current === -1) return;
        event.preventDefault();
        const direction = event.key === 'ArrowRight' ? 1 : -1;
        const next = (current + direction + this.buttons.length) % this.buttons.length;
        this.buttons[next].focus();
        this.select(next);
      }

      select(index) {
        this.buttons.forEach((button, i) => {
          button.classList.toggle('content-tab-button--active', i === index);
          button.setAttribute('aria-selected', i === index ? 'true' : 'false');
        });
        this.tabs.forEach((tab, i) => {
          tab.classList.toggle('content-tab--active', i === index);
        });
        this.refresh(true);
      }

      refresh(animate) {
        const button = this.querySelector('.content-tab-button--active');
        const tab = this.querySelector('.content-tab--active');

        if (this.activeBg && button) {
          if (!animate && !this.ready) this.activeBg.style.transitionDuration = '0s';
          this.activeBg.style.width = button.offsetWidth + 'px';
          this.activeBg.style.height = button.offsetHeight + 'px';
          this.activeBg.style.transform = 'translate(' + button.offsetLeft + 'px, ' + button.offsetTop + 'px)';
          if (!this.ready) {
            requestAnimationFrame(() => {
              this.activeBg.style.transitionDuration = '';
              this.ready = true;
            });
          }
        }

        if (this.panels && tab) {
          this.panels.style.height = tab.offsetHeight + 'px';
        }
      }
    }
  );

  document.addEventListener('shopify:block:select', (event) => {
    const block = event.target;
    const tabs = block.closest('content-tabs');
    if (!tabs || block.dataset.index === undefined) return;
    tabs.select(Number(block.dataset.index));
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["portrait-videos"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('portrait-video-slider')) {
  customElements.define(
    'portrait-video-slider',
    class PortraitVideoSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.portrait-videos__track');
        this.slides = Array.from(this.querySelectorAll('.portrait-videos__slide'));
        this.arrows = Array.from(this.querySelectorAll('.portrait-videos__arrow'));
        this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.autoplay = this.dataset.autoplay === 'true' && !this.reducedMotion;

        this.slides.forEach((slide) => {
          const rect = slide.getBoundingClientRect();
          if (rect.top < window.innerHeight && rect.bottom > 0 && rect.left < window.innerWidth && rect.right > 0) {
            slide.classList.add('is-visible');
          }
        });
        this.classList.add('portrait-videos--initialized');

        this.revealObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                entry.target.classList.add('is-visible');
                this.revealObserver.unobserve(entry.target);
              }
            });
          },
          { threshold: 0.15 }
        );
        this.slides.forEach((slide) => this.revealObserver.observe(slide));

        this.playObserver = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              const video = entry.target.querySelector('video');
              if (!video) return;
              if (entry.intersectionRatio >= 0.6 && this.autoplay && entry.target.dataset.userPaused !== 'true') {
                video.play().catch(() => {});
                entry.target.querySelector('.portrait-video').classList.remove('is-paused');
              } else if (entry.intersectionRatio < 0.6) {
                video.pause();
              }
            });
          },
          { threshold: [0, 0.6] }
        );
        this.slides.forEach((slide) => this.playObserver.observe(slide));

        this.slides.forEach((slide) => {
          const card = slide.querySelector('.portrait-video');
          const video = slide.querySelector('video');
          const toggle = slide.querySelector('.portrait-video__toggle');
          const sound = slide.querySelector('.portrait-video__sound');
          if (!video) return;

          if (!this.autoplay) card.classList.add('is-paused');

          if (toggle) {
            toggle.addEventListener('click', () => {
              if (video.paused) {
                slide.dataset.userPaused = 'false';
                video.play().catch(() => {});
                card.classList.remove('is-paused');
              } else {
                slide.dataset.userPaused = 'true';
                video.pause();
                card.classList.add('is-paused');
              }
            });
          }

          if (sound) {
            sound.addEventListener('click', () => {
              const unmute = video.muted;
              this.querySelectorAll('video').forEach((other) => {
                other.muted = true;
              });
              this.querySelectorAll('.portrait-video').forEach((otherCard) => {
                otherCard.classList.remove('is-unmuted');
              });
              this.querySelectorAll('.portrait-video__sound').forEach((otherSound) => {
                otherSound.setAttribute('aria-pressed', 'false');
              });
              if (unmute) {
                video.muted = false;
                card.classList.add('is-unmuted');
                sound.setAttribute('aria-pressed', 'true');
                if (video.paused && slide.dataset.userPaused !== 'true') {
                  video.play().catch(() => {});
                }
              }
            });
          }
        });

        this.arrows.forEach((arrow) => {
          arrow.addEventListener('click', () => {
            const step = this.slides.length > 0 ? this.slides[0].offsetWidth + 14 : this.track.clientWidth;
            const logical = arrow.dataset.direction === 'next' ? 1 : -1;
            const physical = getComputedStyle(this.track).direction === 'rtl' ? -logical : logical;
            this.track.scrollBy({ left: physical * step, behavior: this.reducedMotion ? 'auto' : 'smooth' });
          });
        });

        this.track.addEventListener('scroll', () => this.updateArrows(), { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.updateArrows());
        this.resizeObserver.observe(this.track);
        this.updateArrows();
      }

      disconnectedCallback() {
        if (this.revealObserver) this.revealObserver.disconnect();
        if (this.playObserver) this.playObserver.disconnect();
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      updateArrows() {
        if (this.arrows.length === 0) return;
        const max = this.track.scrollWidth - this.track.clientWidth;
        const position = Math.abs(this.track.scrollLeft);
        this.arrows.forEach((arrow) => {
          const atStart = position <= 1;
          const atEnd = position >= max - 1;
          if (arrow.dataset.direction === 'previous') {
            arrow.toggleAttribute('disabled', atStart);
          } else {
            arrow.toggleAttribute('disabled', atEnd || max <= 0);
          }
        });
      }

      goTo(index) {
        const slide = this.slides[index];
        if (slide) slide.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      }
    }
  );

  document.addEventListener('shopify:block:select', (event) => {
    const slider = event.target.closest('portrait-video-slider');
    if (!slider) return;
    const slide = event.target.closest('.portrait-videos__slide');
    if (slide && slide.dataset.index !== undefined) {
      slider.goTo(Number(slide.dataset.index));
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
